export const BOOLEAN = {
  T: 'true',
  F: 'false'
};

export const SEATS = {
  ORG: 'origin',
  DEST: 'destination',
  ORDER: 'orderPosCity',
  UPGRADE: 'seatupgrade'
};
